import React from "react";
import { Col, Row } from "reactstrap";
import { T } from "../traks";
import { BinaryToggle } from "./BinaryToggle";

export const RiskValuesSection = ({ simple_checkbox_change, state, me }) => {
    return (
        <React.Fragment>
            {me && me.IsGod && (
            <React.Fragment>
            <span className="txt-15px"><T>With risk enabled, participants are measured not only on their returns but also on the level of risk they took to achieve them. This makes the game more realistic and trains them to assess whether the returns are 'wisely earned'.</T></span>
            <Row className="justify-content-center">
                <Col md="12" className="new_game_premium px-md-4 pt-4 pb-4">
                    <img alt="" className="ad_logo_list" src="/gfx/volume-icon-color-0.svg" /><span className="ad_120_bold pl-2"><T>Leaderboard risk values</T></span>
                    <p>
                        <small><T>Participants' risk scores are displayed directly on their portfolios. On the leaderboard, you can choose between the classic view based on returns - or a view where returns are assessed relative to the risk taken.</T></small><br/>
                    </p>
                    <div className="text-left">
                            <BinaryToggle 
                            name={"use_risk_values"}
                            checked={state.use_risk_values}
                            onChange={simple_checkbox_change}
                            labels={[<T>Activate</T>, <T>Deactivate</T>]}
                            />
                    </div>
                </Col>
            </Row>
        </React.Fragment>
        )}
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/c/RiskValuesSection.js